import(/* webpackMode: "eager" */ "/var/www/html/tvfoco-headless/node_modules/next/dist/client/image-component.js");
